// Firebase initialisation for Branmont mark list
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
import { getAnalytics, isSupported } from "firebase/analytics"

const firebaseConfig = {
	apiKey: "AIzaSyDDp6TCeoj5o6i6tvu4MZRLtYvWSAlfiNQ",
	authDomain: "branmont-website.firebaseapp.com",
	projectId: "branmont-website",
	storageBucket: "branmont-website.firebasestorage.app",
	messagingSenderId: "361326844915",
	appId: "1:361326844915:web:2b2069b48fa4135c2bd086",
	measurementId: "G-HTBKY35FT2",
}

const app = initializeApp(firebaseConfig)

// Firestore database
export const db = getFirestore(app)

// Analytics only in supported (browser) environments — guarded so it never throws
isSupported()
	.then((ok) => {
		if (ok) getAnalytics(app)
	})
	.catch(() => {})

export default app
